import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2cb236be&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=2cb236be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb236be",
  null
  
)

export default component.exports